module.exports = __webpack_public_path__ + "img/T93.bf113b06.jpg";